import React, { Component } from "react";
import Hls from "hls.js";

class VideoPlayerNew extends Component {
  componentDidMount() {
    this.initPlayer();
  }

  componentDidUpdate(prevProps) {
    // যদি src change হয় তাহলে নতুন video load হবে
    if (prevProps.src !== this.props.src) {
      this.destroyPlayer();
      this.initPlayer();
    }
  }

  componentWillUnmount() {
    this.destroyPlayer();
  }

  initPlayer = () => {
    const video = this.video;
    const videoSrc = this.props.src;

    if (!videoSrc) return;

    if (Hls.isSupported()) {
      this.hls = new Hls();
      this.hls.loadSource(videoSrc);
      this.hls.attachMedia(video);
    } else if (video.canPlayType("application/vnd.apple.mpegurl")) {
      video.src = videoSrc;
    }
  };

  destroyPlayer = () => {
    if (this.hls) {
      this.hls.destroy();
      this.hls = null;
    }
  };

  render() {
    return (
      <div style={{ width: "700px", margin: "auto" }}>
        <video
          ref={(ref) => (this.video = ref)}
          controls
          width="100%"
        />
      </div>
    );
  }
}

export default VideoPlayerNew;